// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state
import type { Action } from '@atlassian/react-sweet-state';
import type { TicketType, TicketTypeData } from '../../../common/types.tsx';

const setTicketTypes =
	(ticketTypes: TicketType[]): Action<TicketTypeData> =>
	({ getState, setState }) => {
		const { ticketTypes: currentTicketTypes } = getState();
		const data = { ...currentTicketTypes };

		ticketTypes.forEach((ticketType) => {
			data[ticketType.id.toString()] = {
				currentState: ticketType,
				updateState: {},
			};
		});

		setState({ ticketTypes: data });
	};

export default setTicketTypes;
